// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609020804/js/" + chunkId + "." + {"44":"693cc348","225":"87a26744","481":"ba8a56b5","486":"e381b962","770":"5809fe89"}[chunkId] + ".0.059868041434148256.chunk.js";
};